import React, { useEffect, useRef } from "react";
import { BottomMenuButton } from "../../../bottom-menu/bottom-menu-button";
import {
	BottomMenuButtons,
	IBottomMenuButton,
	IBottomMenuButtonsRef,
} from "../../../bottom-menu/buttons";

export const SymbolsRootMenu = <T extends string = string>({
	showBackButton,
	onBack,
	menuItems,
	activeButtonId,
}: {
	showBackButton: boolean;
	onBack: () => void;
	/** As argument so they can be prefetched */
	menuItems: readonly Omit<IBottomMenuButton<T>, "isActive">[];
	activeButtonId?: string;
}) => {
	const elRef = useRef<IBottomMenuButtonsRef>(null);

	// Scroll the new activeButton into view
	useEffect(() => {
		if (!elRef.current) return;
		const index = menuItems.findIndex((item) => item.id === activeButtonId);
		if (index < 0) return;
		elRef.current.scrollIntoView(index);
	}, [menuItems, activeButtonId]);

	return (
		<BottomMenuButtons ref={elRef} fadeRight showBackButton={showBackButton} onBack={onBack}>
			{menuItems.map(({ id, ...props }) => {
				return <BottomMenuButton {...props} key={id} isActive={activeButtonId === id} />;
			})}
		</BottomMenuButtons>
	);
};
SymbolsRootMenu.displayName = "SymbolsRootMenu";
